import PublishIcon from '@mui/icons-material/Publish';
import { ButtonGroup } from '@mui/material';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { SimulateInboundBollaDialog } from 'features/inventory/purchase-orders/components/SimulateInboundBollaDialog';
import { TenantPage } from 'layouts';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { transportDocumentService } from '../api/transport-document.service';
import { LinkButton, AddButton } from 'components/ui';
import { TransportDocumentColumns } from '../transport-document';

export function TransportDocumentList() {
  const { t } = useTranslation();
  const prefix = 'pages.ddt.list';

  const navigate = useNavigate();
  const datagridRefresh = useRef(null);
  const [simulateDialogOpen, setSimulateDialogOpen] = useState(false);

  const handleSimulateSuccess = () => {
    datagridRefresh.current?.();
  };

  const columns = TransportDocumentColumns(true, null, undefined, true, false);
  const initialFilterItems = [
    {
      id: 1,
      field: 'closed',
      operator: 'is',
      value: false
    }
  ];

  return (
    <TenantPage
      title={t(`${prefix}.title`)}
      subtitle={t(`${prefix}.subtitle`)}
      menuRight={
        <ButtonGroup size="small">
          <LinkButton
            to="invoiced-movements"
            prefix={prefix}
            label="invoiced-movements"
            requirePermission={'tenantAdmin'}
          />
          <AddButton onClick={() => navigate('new')} prefix={prefix} requireTenantAdmin />
          <AddButton
            onClick={() => setSimulateDialogOpen(true)}
            prefix={prefix}
            label="insert_bolla_button"
            icon={PublishIcon}
            requireTenantAdmin
          />
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={columns}
        initialFilterItems={initialFilterItems}
        service={transportDocumentService}
        warehouseFilterParam="warehouse_code"
        refresh={datagridRefresh}
      />
      <SimulateInboundBollaDialog
        open={simulateDialogOpen}
        onClose={() => setSimulateDialogOpen(false)}
        onSuccess={handleSimulateSuccess}
      />
    </TenantPage>
  );
}

export default TransportDocumentList;
